import { BookingInterval, AvailabilityScheduleType, RecurrenceUnit } from '../../types/availability-rules.types';

export const RECURRENCE_OPTIONS = [
  { value: AvailabilityScheduleType.WEEKLY, label: 'Weekly' },
  { value: AvailabilityScheduleType.SPECIFIC_DATE, label: 'Specific Date' },
  { value: AvailabilityScheduleType.RECURRENCE, label: 'Custom' },
];

export const TIME_UNIT_OPTIONS = [
  { value: RecurrenceUnit.DAILY, label: 'Days', min: 1, max: 31 },
  { value: RecurrenceUnit.WEEKLY, label: 'Weeks', min: 1, max: 52 },
  { value: RecurrenceUnit.MONTHLY, label: 'Months', min: 1, max: 12 },
];

export const BOOKING_CADENCE_OPTIONS: { value: BookingInterval; label: string }[] = [
  { value: BookingInterval.NONE, label: 'None' },
  { value: BookingInterval.EVERY_HOUR, label: 'Every hour' },
  { value: BookingInterval.TOP_OF_HOUR, label: 'Top of the hour' },
  { value: BookingInterval.EVERY_TEN_MINUTES, label: 'Every 10 minutes' },
  { value: BookingInterval.EVERY_FIFTEEN_MINUTES, label: 'Every 15 minutes' },
  { value: BookingInterval.EVERY_TWENTY_MINUTES, label: 'Every 20 minutes' },
  { value: BookingInterval.HALF_AN_HOUR, label: 'Every 30 minutes' },
];
